import React from 'react';

interface TextAreaProps extends React.HTMLProps<HTMLTextAreaElement> {
  defaultValue?: string;
  disabled?: boolean;
  id?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  type?: string;
  value?: string;
}

export function TextArea({
  defaultValue,
  disabled,
  id,
  label,
  placeholder,
  required,
  value,
  ...props
}: TextAreaProps) {
  const asterisk = required ? <span className="required-indicator">*</span> : '';

  return (
    <div className="input">
      {label && (
        <label htmlFor={id} className="input-label">
          {label} {asterisk}
        </label>
      )}
      <textarea
        defaultValue={defaultValue}
        disabled={disabled}
        id={id}
        name={id}
        placeholder={placeholder || label}
        value={value}
        {...props}
      />
    </div>
  );
}
